import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { shellStringResources } from 'shell-models-lib';
import {
    getSqlParallelReadMetadataConsts,
    isolationLevelMetadata,
    queryTimeoutMetadata,
} from '../consts/metadata-consts';
import { sqlServerBinaryLengthMap, sqlServerDatasetMetadata, sqlServerLogicalToPhysicalMapping, sqlServerPhysicalToLogicalMapping, sqlServerPrecisionMap, sqlServerScaleMap, sqlServerSupportedPhysicalTypes } from './sqlserver-metadata';
import { sqlBinaryPhysicalTypes } from 'app/shared/utils/column-type.util';

export const fabricSqlTableDatasetMetadata: IDatasetTypeMetadata = {
    ...sqlServerDatasetMetadata,
    type: adfModelTypeMap.fabricSql.datasetType,
    displayName: shellStringResources.SqlDatabase_DisplayText,
    icon: {
        className: 'svg-i_fabricSql'
    },
    supportLinkedServiceTypes: [adfModelTypeMap.fabricSql.linkedServiceType],
    supportDataFlowSink: false,
    supportDataFlowSource: false,
    isDataflowCompatible: false,
    supportDataFlowStoreProcedure: false,

    copySourceControls: [queryTimeoutMetadata].concat([
        isolationLevelMetadata,
        getSqlParallelReadMetadataConsts(adfModelTypeMap.fabricSql.copySourceType)
    ]),
    supportedPhysicalTypes: sqlServerSupportedPhysicalTypes,
    LogicalToPhysicalMapping: sqlServerLogicalToPhysicalMapping,
    PhysicalToLogicalMapping: sqlServerPhysicalToLogicalMapping,
    binaryPhysicalTypes: sqlBinaryPhysicalTypes,
    binaryLengthMap: sqlServerBinaryLengthMap,
    precisionMap: sqlServerPrecisionMap,
    scaleMap: sqlServerScaleMap,
    copyJob: {
        ...sqlServerDatasetMetadata.copyJob,
        multipleQuery: true
    }
};
